import { useActiveRefreshesQuery } from "./queries/useGroupQueries";
import { reportsDashboardEnabled } from "../../utils/features";

// The single source of truth for "is this entity locked?" is whether the
// entity's group is currently refreshing. A report is locked if and only
// if its parent group is locked. A standalone report (no group) cannot
// be locked by a dashboard refresh, because dashboard refresh is a
// group-level operation.
//
// Callers pass the relevant groupId. If the groupId is undefined (because
// the entity does not belong to a group), the hook returns isLocked: false.
export function useRefreshLock(params: { groupId?: string }) {
  const groupId = params.groupId;
  const shouldCheckRefreshLock = reportsDashboardEnabled && !!groupId;
  const { data } = useActiveRefreshesQuery(shouldCheckRefreshLock);

  if (!groupId || !shouldCheckRefreshLock || !data) {
    return { isLocked: false };
  }

  const isLocked = data.refreshingGroups.includes(groupId);
  return { isLocked };
}
